import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { UxRecorderService } from './ux-recorder.service';
import { durationBucket, matchHttpTemplate } from './ux-http-templates';

/** Emits one custom event per finished HTTP call — template + status class only, never the URL. */
export const uxHttpEventInterceptor: HttpInterceptorFn = (req, next) => {
  // Cross-origin requests (hscode-service, docs-service, …) must never carry this header — it
  // would fail their CORS preflight, which doesn't allow it.
  if (/^https?:\/\//i.test(req.url)) return next(req);
  const recorder = inject(UxRecorderService);
  // The api/ux/ guard is future-proofing, not a live path today: the recorder's own traffic goes
  // through raw fetch() (see ux-recorder.service.ts), never HttpClient, so this never fires yet.
  if (!recorder.active || req.url.startsWith('api/ux/')) return next(req);
  const started = Date.now();
  let status = 0;
  const tagged = req.clone({ headers: req.headers.set('X-Ux-Session', recorder.sessionId ?? '') });
  return next(tagged).pipe(
    tap({
      next: (e) => {
        if (e instanceof HttpResponse) status = e.status;
      },
      error: (err) => {
        status = err?.status ?? 0;
      },
    }),
    finalize(() => {
      recorder.emit('http', {
        template: matchHttpTemplate(req.method, req.url),
        status,
        durationBucket: durationBucket(Date.now() - started),
      });
    })
  );
};
